import { CheckmarkCircleRegular, ErrorCircleRegular, PlugConnectedRegular } from '@fluentui/react-icons'
import type { ConnectionStatus as ConnectionStatusType } from '@/types/chat'
import styles from './ConnectionStatus.module.css'

interface ConnectionStatusProps {
  status: ConnectionStatusType
}

const statusMeta: Record<ConnectionStatusType, { label: string; tone: 'ok' | 'busy' | 'error' }> = {
  idle: { label: 'Neconectat', tone: 'busy' },
  authenticating: { label: 'Autentificare…', tone: 'busy' },
  connecting: { label: 'Conectare la agent…', tone: 'busy' },
  connected: { label: 'Conectat', tone: 'ok' },
  sending: { label: 'Se procesează…', tone: 'busy' },
  error: { label: 'Conexiune întreruptă', tone: 'error' },
}

export function ConnectionStatus({ status }: ConnectionStatusProps) {
  const meta = statusMeta[status]
  const Icon = meta.tone === 'error' ? ErrorCircleRegular : meta.tone === 'ok' ? CheckmarkCircleRegular : PlugConnectedRegular

  return (
    <div className={`${styles.root} ${styles[meta.tone]}`}>
      <Icon className={styles.icon} aria-hidden="true" />
      <span>{meta.label}</span>
    </div>
  )
}
